import { is_not } from '@vee-validate/rules'
import { defineRule } from 'vee-validate'

const isNotExtend = () => {
  defineRule<string, string[]>(
    'is_not_extend',
    (value, [compareValue], _ctx: any) => {
      return is_not(value, { other: compareValue })
    },
  )
}

export default isNotExtend
